export default __webpack_public_path__ + "2ff640440dcb06ef24eb799df8bb6f9b.png";